import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Shield, DollarSign } from 'lucide-react'
import api from '../config/api'
import { useI18n } from '../hooks/useI18n'
import '../styles/TrustBalance.css'

function TrustBalance() {
  const { t } = useI18n()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTrustBalance()
  }, [])

  const fetchTrustBalance = async () => {
    try {
      const response = await api.get('/trust-balance')
      setData(response.data.data)
    } catch (err) {
      console.error('Failed to load trust balance:', err)
    } finally {
      setLoading(false)
    }
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-PH', {
      style: 'currency', currency: 'PHP', minimumFractionDigits: 2
    }).format(amount || 0)
  }

  if (loading) {
    return <div className="trust-loading"><div className="loading-spinner" /><p>{t('common.loading')}</p></div>
  }

  return (
    <div className="trust-page">
      <div className="page-header">
        <h1>Trust Account</h1>
        <p>Your IOLTA trust account balances</p>
      </div>

      {/* Total Balance */}
      <motion.div className="trust-total-card" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="trust-total-icon">
          <Shield size={28} />
        </div>
        <div>
          <div className="trust-total-label">Total Trust Balance</div>
          <div className="trust-total-amount">{formatCurrency(data?.totalBalance)}</div>
        </div>
      </motion.div>

      {/* Account List */}
      {data?.accounts?.length === 0 ? (
        <div className="trust-empty">No trust accounts found</div>
      ) : (
        <div className="trust-accounts-grid">
          {data?.accounts?.map((account, index) => (
            <motion.div key={account.id} className="trust-account-card"
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}>
              <div className="trust-account-header">
                <DollarSign size={20} />
                <span className="trust-account-number">{account.accountNumber}</span>
              </div>
              <div className="trust-account-balance">{formatCurrency(account.balance)}</div>
              {account.matterTitle && (
                <div className="trust-account-matter">{account.matterTitle}</div>
              )}
            </motion.div>
          ))}
        </div>
      )}
    </div>
  )
}

export default TrustBalance
